var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState, useCallback } from 'react';
import Collapsible from 'react-collapsible';
import { useDispatch } from 'react-redux';
import { apiCreateClientOfferDetailViewEvent } from '../../../../../../../actions/ClientRfpActions';
import { RFP_EVENT_TYPE_CLIENT_OFFER_VIEW } from '../../../../../../../define/consts/rfp/rfp_event';
import { wrapDispatch } from '../../../../../../../helpers/action';
import { emptyFunc, sleep } from '../../../../../../../helpers/common';
import { numberFormat } from '../../../../../../../helpers/common/StringHelper';
import { propBool, propFunc, propNumber, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { scrollToWithHeaderHeight } from '../../../../../../../helpers/ScrollUtils';
import UserPreviewState from '../../../../../../../helpers/user/UserPreviewState';
import AdditionalFilesRow from '../../AdditionalFiles/AdditionalFilesRow';
import CharmPointRow from '../../CharmPoint/CharmPointRow';
import MemberRows from '../../Member/MemberRows';
import DirectAnswerRow from './DirectParts/DirectAnswerRow';
import OfferInputColumn from './OfferInputColumn';
const OfferBottomRowDirect = (props) => {
    const { charmPoint, driverTargetRef, isActiveDriverTarget, isCharmPointDisabled, onChange, onChangeComplete, onClickDriverTarget, rfp, viewRequest, } = props;
    const { id, offer: { additional_files: additionalFiles, answer, charm_points: charmPoints, is_view: rawIsView, max_period: maxPeriod, max_price: maxPrice, period, price, }, offer_members: offerMembers, } = viewRequest;
    const dispatch = useDispatch();
    const [isView, changeIsView] = useState(rawIsView);
    const { id: rfpId } = rfp;
    const [isOpen, changeIsOpen] = useState(false);
    const toggleIsOpen = useCallback(() => {
        changeIsOpen((prev) => {
            if (!UserPreviewState.isPreview && !isView && prev === false) {
                const action = apiCreateClientOfferDetailViewEvent(rfpId, viewRequest.id, RFP_EVENT_TYPE_CLIENT_OFFER_VIEW);
                wrapDispatch(dispatch, action).then(emptyFunc);
                changeIsView(true);
            }
            return !prev;
        });
    }, [changeIsOpen, rfpId, dispatch, viewRequest, isView, changeIsView]);
    const hideIsOpen = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        scrollToWithHeaderHeight(`offer_row_${id}`);
        yield sleep(0.8);
        changeIsOpen(false);
    }), [id, changeIsOpen]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'bottom_row is-direct' }, { children: [_jsxs("div", Object.assign({ className: clsx('view_link_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: [_jsx("span", Object.assign({ className: `tag ${isView ? 'tag_read' : 'tag_unread'}` }, { children: isView ? '既読' : '未読' })), _jsxs("button", Object.assign({ className: `view_link ${isOpen ? 'is_open' : ''}`, onClick: toggleIsOpen, type: 'button' }, { children: ["\u63D0\u6848\u5185\u5BB9\u3092\u898B\u308B", _jsx("i", { className: `material-icons ${isOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}` })] }))] })), _jsx(OfferInputColumn, { hasAdditionalFiles: additionalFiles.length > 0, periodText: period && maxPeriod
                            ? `約${period}週間〜約${maxPeriod}週間`
                            : `約${period || maxPeriod}週間`, priceText: price && maxPrice
                            ? `${numberFormat(price)}万円〜${numberFormat(maxPrice)}万円`
                            : `${numberFormat(price || maxPrice)}万円`, showAdditionalFiles: true })] })), _jsx(Collapsible, Object.assign({ open: isOpen, transitionTime: 250, trigger: '' }, { children: _jsxs("div", Object.assign({ className: 'direct_rfp_content' }, { children: [_jsx("div", Object.assign({ className: 'charmpoint_row' }, { children: _jsx(CharmPointRow, { charmPoint: charmPoint, charmPoints: charmPoints, isDisabled: isCharmPointDisabled, onChange: onChange, onChangeComplete: onChangeComplete }) })), _jsx(AdditionalFilesRow, { additionalFiles: additionalFiles }), _jsx(DirectAnswerRow, { answer: answer || '' }), _jsx(MemberRows, { offerMembers: offerMembers }), _jsxs("button", Object.assign({ className: 'collapse_close', onClick: hideIsOpen, type: 'button' }, { children: [_jsx("span", { children: "\u63D0\u6848\u5185\u5BB9\u3092\u9589\u3058\u308B" }), _jsx("i", { className: 'material-icons keyboard_arrow_up' })] }))] })) }))] }));
};
OfferBottomRowDirect.propTypes = {
    charmPoint: propNumber(),
    driverTargetRef: propShape(),
    isActiveDriverTarget: propBool(),
    isCharmPointDisabled: propBool().isRequired,
    onChange: propFunc().isRequired,
    onChangeComplete: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
    rfp: propShape().isRequired,
    viewRequest: propShape().isRequired,
};
OfferBottomRowDirect.defaultProps = {
    charmPoint: null,
    driverTargetRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default OfferBottomRowDirect;
